import * as Constants from '../../Pages/Constants';
import { withStyles } from '@material-ui/core';
import { useCallback } from 'react';
import React, { useState, useEffect, useRef } from "react";
import { FormattedMessage } from 'react-intl';
import { Row, Col, Card } from 'antd'
import Button from '@material-ui/core/Button';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { Range, getTrackBackground } from 'react-range';
import Switch from "react-switch";
import PostDataController from '../../Controller/PostDataController.js';

const AlimentationForm = (props) => {

  const { classes } = props;
  const [step, setStep] = useState(0);
  const options = [0, 1];
  const [formType, setFormType] = useState({label: "form_type", value:"ALIMENTATION"})
  const optionsLabels = ["transit", "pain", "alimentation"];
  const [optionSelected, setOptionSelected] = useState("-1");
  const [message, setMessage] = useState("");
  const [results, setResults] = useState([{label: "registered_by", value:-1}, {label: "transit_one", value:-1}, {label:"transit_two", value:-1}, {label:"transit_three", value:-1}, {label:"pain_one", value:-1}, {label:"pain_two", value:-1}, {label:"alimentation_one", value:[-1,-1,-1,-1]}, {label:"alimentation_two", value:-1}, {label:"alimentation_three", value:-1}]);

  const toggleSelect = (e,name, index_inside) => {
    let newResults = [...results]
    let index = results.findIndex(result => result.label === name)
    if (name === "alimentation_one") {
      let value = newResults[index].value
      value[index_inside] = Number(e.target.value)
      newResults[index] = {label:name, value:value}
    }
    else {
      newResults[index] = {label:name, value:Number(e.target.value)}
    }
    setResults(newResults)
  }

  const generateSelect = (name, i, ligne, index_inside) => {
    let index = results.findIndex(result => result.label === name)
    let selected
    if (name === "alimentation_one") {
      selected = results[index].value[index_inside]
    }
    else {
      selected = results[index].value      
    }
    return (
      <Row style={{width:"100%", color: "black", justifyContent: 'right'}}>
        <Col style={{display: 'flex', alignItems: 'center', justifyContent: 'right'}}>
          <select value={selected} onChange={(e) => toggleSelect(e, name, index_inside)} id={"answer_selector"+i} name={"answer_selector"+i} style={{maxWidth:"100%", margin:"0%"}}>
            <option value={'-1'} key={-1}>{}</option>
            <option value={0} key={0}>{props.intl.formatMessage({id: "monitoring.switch.label.yes"})}</option>
            <option value={1} key={1}>{props.intl.formatMessage({id: "monitoring.switch.label.no"})}</option>
          </select>
        </Col>
      </Row>
    )
  }

  //Function to return row with only switch element
  const renderAlertSelectRow = (titleID, defaultTitle, alertType, handleChange, checked, subquestion, index) => {
    return(
      <Row>
        {subquestion ?
        <Col style={{width:"70%"}}>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;-&nbsp;
          <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
        </Col>
          :
          <Col style={{width:"70%"}}>
            <FormattedMessage id={titleID} defaultMessage={defaultTitle}/>
          </Col>
          }
        <Col style={{width:"30%", justifyContent: 'right'}}>
          {generateSelect(alertType, handleChange, checked, index)}
        </Col>
      </Row>
    );
  }

  const sendingForm = async () => {
    let to_send = [...results];
    let index = to_send.findIndex(result => result.label === "registered_by")
    to_send[index].value = props.accountInformation.username;
    to_send.unshift(formType);
    let current_Date = new Date()                                                                         // Get current date  
    await PostDataController.post_observation(current_Date, to_send, "health_form", props.id_patient);    // Send data in backend
    await props.update(current_Date, to_send, props.BannerDisplayedAlerts);                                             // update display
    props.cancelPopup();
  }

  const changeValue = (e, check) => {
    let newResult = [...results];
    let index = results.findIndex(result => result.label === check)
    newResult[index] = {label:check, value:e === true ? 1 : 0}
    setResults(newResult);
  }

  const changeStep = (direction) => {
    if (direction === "next") {
      if (step === optionsLabels.length-1) {
        sendingForm()
      }
      else {
          let newResult = [...results];
          let index = (newResult.findIndex(obj => obj.label === optionsLabels[step]))
          newResult[index] = {label:optionsLabels[step], value:parseInt(optionSelected)}
          setResults(newResult);
          setMessage("");
          setOptionSelected(String(newResult[index + 1].value));
          setStep(step+1);
      }
    }
    else if (direction === "previous") {
      setMessage("");
      setStep(step-1);
      setOptionSelected(String(results[step-1].value));
    }
  }

  const toggleCheckbox = (e, index) => {
    let newResult = [...results];
    newResult = newResult.slice()
    let index_inside = (newResult.findIndex(obj => obj.label === "alimentation_one"))
    newResult[index_inside].value[index] = e.target.checked ? 1 : 0
    setResults(newResult);
  }

  const generatePageTransit = () => {
    const lignes = [
      {id:"alimentation.form.transit.one", defaultMessage:"Have you had any gas (farts, flatulence) today?", check:"transit_one"},
      {id:"alimentation.form.transit.two", defaultMessage:"Have you had a bowel movement today?", check:"transit_two"},
      {id:"alimentation.form.transit.three", defaultMessage:"Have you felt nauseous or vomited today?", check:"transit_three"}
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="alimentation.form.transit.title" defaultMessage="Transit"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {lignes.map((ligne) => {
          let checked = results.find(result => result.label === ligne.check).value
          return (
            <div>
              <Row style={{width:"100%", color: "black"}}>
                <Col style={{width:"100%"}}>
                  <div style={{textAlign: 'left', width:"100%"}}>
                    {renderAlertSelectRow(ligne.id, ligne.defaultMessage, ligne.check, (e) => changeValue(e, ligne.check), checked, false)}
                  </div>
                </Col>
              </Row>
            </div>
          )
        })}
      </div>
    )
  }

  const generatePagePain = () => {
    const lignes = [
      {id:"alimentation.form.pain.one", defaultMessage:"Is your pain sufficiently relieved by the treatment?", check:"pain_one"},
      {id:"alimentation.form.pain.two", defaultMessage:"Do you need a member of the team to contact you to help you adapt your analgesic treatment?", check:"pain_two"}
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="alimentation.form.pain.title" defaultMessage="Pain / Analgesics"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {lignes.map((ligne) => {
          let checked = results.find(result => result.label === ligne.check).value
          return (
            <div>
              <Row style={{width:"100%", color: "black"}}>
                <Col style={{width:"100%"}}>
                  <div style={{textAlign: 'left', width:"100%"}}>
                    {renderAlertSelectRow(ligne.id, ligne.defaultMessage, ligne.check, (e) => changeValue(e, ligne.check), checked, false)}
                  </div>
                </Col>
              </Row>
            </div>
          )
        })}
      </div>
    )
  }

  const generatePageAlimentation = () => {
    const lignes = [
      {id:"alimentation.form.alimentation.one", defaultMessage:"What was your diet the day before (several choices possible)?", check:"alimentation_one"},
      {id:"alimentation.form.alimentation.two", defaultMessage:"Do you think you eat more today than you did yesterday?", check:"alimentation_two"},
      {id:"alimentation.form.alimentation.three", defaultMessage:"Do you need a team member to contact you to help you adapt your diet?", check:"alimentation_three"}
    ];
    const lignes_one = [
      {id:"alimentation.form.alimentation.one.one", defaultMessage:"Agua/bebidas sin alcohol", check:"alimentation_one"},
      {id:"alimentation.form.alimentation.one.two", defaultMessage:"Yogur/compota", check:"alimentation_one"},
      {id:"alimentation.form.alimentation.one.three", defaultMessage:"Comida ligera como puré de patatas/jamón", check:"alimentation_one"},
      {id:"alimentation.form.alimentation.one.four", defaultMessage:"Alimentación casi normal", check:"alimentation_one"},
    ];
    return (
      <div>
        <Row style={{ fontWeight: "bold", fontSize:"1.2em", color: "black"}}>
          <FormattedMessage id="alimentation.form.alimentation.title" defaultMessage="Nourishment"/>
        </Row>
        <b style={{color: "black"}}>{message}</b>
        {lignes.map((ligne, index) => {
          if (index !== 0) {
            let checked = results.find(result => result.label === ligne.check).value
            return (
              <div>
                <Row style={{width:"100%", color: "black"}}>
                  <Col style={{width:"100%"}}>
                    <div style={{textAlign: 'left', width:"100%"}}>
                      {renderAlertSelectRow(ligne.id, ligne.defaultMessage, ligne.check, (e) => changeValue(e, ligne.check), checked, false)}
                    </div>
                  </Col>
                </Row>
                <br/>
              </div>
            )
          }
          else {
            return (
              <div>
                <Row style={{color: "black", display: 'flex', textAlign: 'justify'}}>
                  <FormattedMessage id="alimentation.form.alimentation.one" defaultMessage="What was your diet the day before (several choices possible)?"/>
                </Row>
                {lignes_one.map((ligne, index) => {
                  let checked = results.find(result => result.label === "alimentation_one").value[index]
                  return (
                    <Row style={{width:"100%", color: "black"}}>
                      <Col style={{width:"100%"}}>
                        <div style={{textAlign: 'left'}}>
                          {renderAlertSelectRow(ligne.id, ligne.defaultMessage, ligne.check, (e) => changeValue(e, ligne.check), checked, true, index)}
                        </div>
                      </Col>
                    </Row>
                  )
                })}
                <br/>
              </div>
            )
          }
        })}
      </div>
    )
  }

  const generatePage = () => {
    switch(step) {
    case 0 :
      return (generatePageTransit())
    case 1 :
      return (generatePagePain())
    case 2 :
      return (generatePageAlimentation())
    default :
      return (null);
    }
  }

  const generateStep = () => {
    return (
      <div>
        <Row style={{ display: 'flex', justifyContent: 'center', fontWeight: "bold", fontSize:"2.2em", color: "black"}}>
            <FormattedMessage id="alimentation.form.title.main" defaultMessage="Health Questionnaire"/>
        </Row>
        <br/>
        <Row style={{ color: "black", display: 'flex', textAlign: 'justify'}}>
          <FormattedMessage id="eq5d.form.instruction.page" defaultMessage="Please select the ONE box that best describes your health TODAY."/>
        </Row>
        <br/>
        {generatePage()}
        <br/>
        <Button
          disabled={step===0}
          variant="contained"
          color="default"
          startIcon={<ArrowBackIcon />}
           onClick={() => changeStep("previous")}
        >
          <FormattedMessage id="eq5d.form.arrow.previous" defaultMessage="Previous"/>
        </Button>
        <Button
          variant="contained"
          color="default"
          startIcon={<ArrowForwardIcon />}
           onClick={() => changeStep("next")}
        >
          <FormattedMessage id="eq5d.form.arrow.next" defaultMessage="Next"/>
        </Button>
      </div>
    )
  }

  let generalFormWidth = "75%"
  if (props.screenSize.width < 800) {
    generalFormWidth = "100%"
  }
  return (
    <div className={classes.popup_background}>
      <div style={{ width:{generalFormWidth}, height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form" style={{ borderRadius: "5px"}}>
          {generateStep()}
          <button onClick={props.cancelPopup} className="btn btn-danger">
            <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
          </button>
        </div>
      </div>
    </div>
  );

}
export default withStyles(Constants.styles)(AlimentationForm);
